import { useState } from "react";
import { PlusIcon, MinusIcon } from '@heroicons/react/16/solid';
import { Table, TableBody, TableCell, TableRow } from '../../components/table'
import { Field, Label } from '../../components/fieldset'
import { Button } from '../../components/button'
import { Listbox, ListboxLabel, ListboxOption } from '../../components/listbox'
import config from '../../config.js'

export function ProductsSelection({ handleFieldChange, AddInclusionFields, removeInclusionCondition, updateAIFieldAtIndex, errors, formData }) {
    const [showInclusionTab, setShowInclusionTab] = useState(true);  // Visible by default
    const [showExclusionTab, setShowExclusionTab] = useState(false); // Hidden by default
    const [inclusionType, setInclusionType] = useState(formData.inclusion_type);

    return (
    <>
    <div className="space-y-12 sm:space-y-16">
        <div className="divide-y divide-gray-200 rounded-lg bg-white shadow-sm">
            <div className="px-4 py-3 sm:px-4 font-medium cursor-pointer" onClick={() => setShowInclusionTab((prev) => !prev)}>
                Inclusion Settings
            </div>
            <div className={`px-3 py-4 dark:bg-zinc-900 ${showInclusionTab ? "" : "hidden"}`}>
                <div className="space-y-12 sm:space-y-16">
                    <div>
                        <div className="space-y-8 pb-12 sm:space-y-0 sm:pb-0">
                            <div className="sm:grid sm:grid-cols-4 sm:gap-4 sm:py-2">
                                <Field>
                                    <Label className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">Product Inclusion</Label>
                                </Field>
                                <div className="mt-2 sm:col-span-1 sm:mt-0">
                                    <div className="grid grid-cols-1 sm:max-w-xs">
                                        <Listbox name="inclusion_type" defaultValue="all" value={formData.inclusion_type} onChange={(value) => { handleFieldChange({ name: 'inclusion_type', value: value }); setInclusionType(value);}}>
                                            <ListboxOption value="all">
                                                <ListboxLabel>All Products</ListboxLabel>
                                            </ListboxOption>
                                            <ListboxOption value="filter_based">
                                                <ListboxLabel>Filter based</ListboxLabel>
                                            </ListboxOption>
                                        </Listbox>
                                    </div>
                                </div>
                            </div>
                            <div className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:py-2 overflow-x-auto ${inclusionType === "filter_based" ? "" : "!hidden"}`}>
                                <Table className="[--gutter:--spacing(6)] lg:[--gutter:--spacing(10)] divide-y divide-gray-300 min-w-3xl">
                                    <TableBody className="divide-y divide-gray-200">
                                        {formData.ai_fields.map((value, index) => (
                                            <TableRow key={index} className={`row_number_${index}`}>
                                                <TableCell>Add products for which the</TableCell>
                                                <TableCell>
                                                    <div className="grid">
                                                        <Listbox name={`filter_field[${index}]`} className={`min-w-40 outline-1 -outline-offset-1 appearance-none rounded-md ${
                                errors.ai_fields?.[index] ? "outline-red-300" : "outline-gray-300"}`} defaultValue="" value={value} onChange={(value) => { updateAIFieldAtIndex(index, value) }}>
                                                            <ListboxOption key="empty" value="">
                                                                <ListboxLabel>-Select-</ListboxLabel>
                                                            </ListboxOption>
                                                            {Object.entries(config.aiFieldsOP).map(([key, label]) => (
                                                                <ListboxOption key={key} value={key}>
                                                                    <ListboxLabel>{label}</ListboxLabel>
                                                                </ListboxOption>
                                                            ))}
                                                        </Listbox>
                                                    </div>
                                                    {errors.ai_fields && errors.ai_fields[index] && <p className="text-red-500 text-sm mt-1">{errors.ai_fields[index]}</p>}
                                                </TableCell>
                                                <TableCell>have changed.</TableCell>
                                                <TableCell className="!px-2 !py-2">
                                                    {index === 0 && (
                                                        <Button outline onClick={() => AddInclusionFields()}>Add</Button>
                                                    )}
                                                    {index >= 1 && (
                                                        <Button onClick={() => removeInclusionCondition(index)}>Remove</Button>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="space-y-12 sm:space-y-16 mt-4 hidden">
        <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm">
            <div className="px-4 py-3 sm:px-4 bg-gray-300 font-medium cursor-pointer" onClick={() => setShowExclusionTab((prev) => !prev)}>
                Exclusion Settings
            </div>
            <div className={`px-3 py-4 dark:bg-zinc-900 ${showExclusionTab ? "" : "hidden"}`}>{/* Content goes here */}</div>
        </div>
    </div>
    </>
  );
}